import React from "react"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"
import { motion } from "framer-motion"
import { useInView } from "react-intersection-observer"

export default function Clientlogos() {
  const data = useStaticQuery(graphql`
    query ClientLogosQuery {
      
      prismicHomepageBodyClientLogo {
        items {
          logo {
            alt
            fluid {
              ...GatsbyPrismicImageFluid_noBase64
            }
          }
        }
      }
    }
  `)

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: false,
  })

  const variants = {
    show: { opacity: 1, transition: { duration: 0.3, staggerChildren: 0.1 } },
    hide: { opacity: 0, transition: { duration: 0.3 } },
  }
  const item = {
    show: { opacity: 1, y: 0, transition: {duration: .3} },
    hide: { opacity: 0, y: -5, transition: {duration: .3} },
  }
  return (
    <motion.div>
      <motion.div
        className="flex flex-row lg:max-w-3xl lg:mx-auto mt-12 md:mt-0 md:mb-24 mb-12 px-2"
        variants={variants}
        animate={inView ? "show" : "hide"}
        initial="hide"
        ref={ref}
      >
        {data.prismicHomepageBodyClientLogo.items.map(({ logo }, index) => (
          <motion.div
            className="px-2 md:px-10 lg:px-10 flex-1"
            variants={item}
            key={index}
          >
            <Img fluid={logo.fluid} />
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  )
}
